import { useContext, useCallback, useMemo, useEffect } from 'react'
import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import { object } from 'prop-types'
import { CvsAutoComplete } from '@components'
import { connectorContext, folderContext } from '@contexts'
import { templateCopyContext } from '../context'
import { FileFormPartial } from './file-form-partial'

const Flex = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-top: -8px;
`

const FullWidth = styled.div`
  width: 100%;
`

const MarginLeft = styled(CvsAutoComplete)`
  margin-left: 12px;
`

export const GoogleCloud = ({ assignment }) => {
  const { onChange } = useContext(templateCopyContext)
  const { byConnectorId, fetchFolderByConnectorId } = useContext(folderContext)
  const { byId } = useContext(connectorContext)
  const connectors = useMemo(
    () =>
      Object.values(byId)
        .filter(
          connector =>
            connector.connector_type_id ===
            (assignment.connector_type_id
              ? assignment.connector_type_id
              : byId[assignment.connector_id].connector_type_id),
        )
        .map(({ name, id }) => ({
          label: name,
          value: id,
        })),
    [byId, assignment],
  )

  useEffect(() => {
    fetchFolderByConnectorId(assignment.connector_id)
  }, [fetchFolderByConnectorId, assignment])

  const folderOptions = useMemo(
    () =>
      byConnectorId[assignment.connector_id] &&
      byConnectorId[assignment.connector_id].map(f => ({ value: f, label: f })),
    [byConnectorId, assignment],
  )

  const onGoogleCloudChange = useCallback(
    (value, name) => {
      onChange(old => ({
        ...old,
        [assignment.id]: {
          ...old[assignment.id],
          [name]: value,
        },
      }))
    },
    [onChange, assignment],
  )

  return (
    <FullWidth>
      <FileFormPartial assignment={assignment}>
        <Flex>
          <CvsAutoComplete
            options={connectors || []}
            label={t`Google account`}
            selected={assignment.connector_id}
            onSelected={value => onGoogleCloudChange(value, 'connector_id')}
          />
          <MarginLeft
            options={folderOptions || []}
            label={t`Destination bucket`}
            selected={assignment.folder_name}
            onSelected={value => onGoogleCloudChange(value, 'folder_name')}
          />
        </Flex>
      </FileFormPartial>
    </FullWidth>
  )
}

GoogleCloud.propTypes = {
  assignment: object.isRequired,
}
